/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider } from "@mantine/core";

export default function SecurityCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Security of Your Personal Data</Title>
      <Divider my="md" />
      <Text>
        The security of Your Personal Data is important to Us, but remember that
        no method of transmission over the Internet, or method of electronic
        storage is 100% secure. While We strive to use commercially acceptable
        means to protect Your Personal Data, We cannot guarantee its absolute
        security.
      </Text>
    </Card>
  );
}
